import React from 'react';
import { AnyAbility } from '@casl/ability';
import { createContextualCan } from '@casl/react';

/**
 * Contexte CASL d'autorisation.
 *
 * Extrait dans son propre fichier feuille (react + @casl uniquement) afin que les
 * hooks bas-niveau (`useAbilityContext`) puissent l'importer sans passer par le
 * baril `@/components`, ce qui créait de nombreux cycles d'imports.
 */
export const AbilityContext = React.createContext<AnyAbility>(
  undefined as unknown as AnyAbility,
);
export const Can = createContextualCan(AbilityContext.Consumer);
